import { Fragment, ReactNode } from 'react';
import { TextSegment } from './textDiffRows';

const renderSegment = ({ text, changed, start }: TextSegment) =>
  changed ? <mark key={start}>{text}</mark> : <Fragment key={start}>{text}</Fragment>;

export const renderLineText = ({ text, segments }: { text: string; segments?: TextSegment[] }): ReactNode =>
  segments ? segments.map(segment => renderSegment(segment)) : text;
